import { ShimmerMetricRow, ShimmerTwoCol } from "./DashboardShimmer";
import AverageWeights from "./AverageWeights";
import LossMetrics from "./LossMetrics";
import "./dashboard-sections.css";
import DashboardSummaryBox from "./DashboardSummaryBox";

const DUMMY = {
  total_paid_cases:  12450,
  total_paid_kg:     249000,
  total_orange_kg:   184200,
  total_ripened_kg:  58600,
  total_rejected_kg: 4120,
};

const FreshFruitRunningTotals = ({ data = DUMMY, isLoading = false }) => {
  const metrics = [
    { label: "Total Paid Cases",  value: data.total_paid_cases?.toLocaleString(),  unit: "",   badge: "+4%" },
    { label: "Total Paid KG",     value: data.total_paid_kg?.toLocaleString(),     unit: "kg"  },
    { label: "Total Orange KG",   value: data.total_orange_kg?.toLocaleString(),   unit: "kg"  },
    { label: "Total Ripened KG",  value: data.total_ripened_kg?.toLocaleString(),  unit: "kg"  },
    { label: "Total Rejected KG", value: data.total_rejected_kg?.toLocaleString(), unit: "",   danger: true, dot: true },
  ];

  return (
    <div className="db-section">
      {/* Section header */}

      {/* Sub-sections inside Fresh Fruit Running Totals */}
      <div className="db-subsections">
        <AverageWeights isLoading={isLoading} />
        <LossMetrics isLoading={isLoading} />
      </div>
    </div>
  );
};

export default FreshFruitRunningTotals;
